import { createFileRoute } from "@tanstack/react-router"

import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_header/devices/$id/fwupdate/")({
  beforeLoad: async ({ context, params }) => {
    // RBAC: only allow users with the iot:device::update permission to access this route.
    // Only a FE lock, as this is entirely board-logic.
    await routeGuard(context, {
      permission: { flag: "iot:device::update", fallbackRoute: { to: "/devices/$id", params: { id: params.id } } }
    })
  }
})
